module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon4b.309d64fe.png";